import VStack from "@/components/Layout/VStack";
import { cn } from "@/lib/cn";
import type { PropsWithChildren } from "react";
import { useEffect, useRef, useState } from "react";
import { useCompoundChartContext } from "./context";

export function CompoundChartTooltip({ children }: PropsWithChildren) {
  const { hoveredDatum } = useCompoundChartContext();
  const [position, setPosition] = useState({ x: 0, y: 0 });
  const tooltipRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!hoveredDatum) return;

    const handleMouseMove = (event: MouseEvent) => {
      setPosition({ x: event.clientX, y: event.clientY });
    };

    document.addEventListener("mousemove", handleMouseMove);
    return () => document.removeEventListener("mousemove", handleMouseMove);
  }, [hoveredDatum]);

  if (!hoveredDatum) return null;

  return (
    <VStack
      ref={tooltipRef}
      className={cn(
        "pointer-events-none fixed z-50 w-max -translate-y-1/2 translate-x-5 gap-2 rounded-lg bg-secondary p-3 drop-shadow",
        "text-pSmall",
      )}
      style={{ top: position.y, left: position.x }}
    >
      <svg
        className="absolute left-0 top-1/2 -translate-x-full -translate-y-1/2 fill-secondary"
        width={8}
        height={16}
      >
        <polygon points="8,0 8,16 0,8" />
      </svg>
      {children}
    </VStack>
  );
}
